export const MAJOR = 1; 
export const MINOR = 2; 
export const HARMONIC_MINOR = 3; 

export const SCALE_TO_ARRAY = {
    1: [0, 2, 4, 5, 7, 9, 11],
    2: [0, 2, 3, 5, 7, 8, 10],
    3: [0, 2, 3, 5, 7, 8, 11]
};

